import { OktaAuth } from '@okta/okta-auth-js'
import { Config } from '../config/Config'

export const oktaAuth = new OktaAuth({
  devMode: false,
  issuer: Config.oidc.issuer,
  clientId: Config.oidc.clientId,
  redirectUri: Config.oidc.redirectUri,
  scopes: Config.oidc.scopes,
  pkce: Config.oidc.pkce,
})
